import * as history from 'history';

const reactRouterHistory = history.createBrowserHistory();

export default reactRouterHistory;
